import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-33676792"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "base64-converter"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Base64 加密、解密", -1));
const _hoisted_3 = {
  class: "input-group"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "utf-8"
}, "UTF-8", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "gb2312"
}, "GB2312", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "utf-8-uri"
}, "UTF-8-URI", -1));
const _hoisted_7 = [_hoisted_4, _hoisted_5, _hoisted_6];
const _hoisted_8 = {
  class: "input-group"
};
import { ref } from 'vue';
import iconv from 'iconv-lite';
export default {
  __name: 'BasePassword',
  setup(__props) {
    const inputText = ref('');
    const outputText = ref('');
    const encoding = ref('utf-8');

    // Base64 加密
    const base64Encode = () => {
      let text = inputText.value;
      try {
        if (encoding.value === 'utf-8') {
          outputText.value = btoa(unescape(encodeURIComponent(text)));
        } else if (encoding.value === 'gb2312') {
          const buffer = iconv.encode(text, 'gb2312');
          outputText.value = btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)));
        } else if (encoding.value === 'utf-8-uri') {
          outputText.value = btoa(encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16))));
        }
      } catch (error) {
        outputText.value = '加密错误，请检查输入内容';
      }
    };

    // Base64 解密
    const base64Decode = () => {
      let text = inputText.value;
      try {
        if (encoding.value === 'utf-8') {
          outputText.value = decodeURIComponent(escape(atob(text)));
        } else if (encoding.value === 'gb2312') {
          const buffer = new Uint8Array(atob(text).split('').map(c => c.charCodeAt(0)));
          outputText.value = iconv.decode(buffer, 'gb2312');
        } else if (encoding.value === 'utf-8-uri') {
          outputText.value = decodeURIComponent(atob(text).replace(/[A-Za-z0-9+/=]/g, c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)));
        }
      } catch (error) {
        outputText.value = '解密错误，输入不是有效的 Base64 字符串';
      }
    };

    // 交换内容
    const swapContents = () => {
      [inputText.value, outputText.value] = [outputText.value, inputText.value];
    };

    // 清空内容
    const clearContents = () => {
      inputText.value = '';
      outputText.value = '';
    };

    // 下载代码
    const downloadCode = () => {
      const code = `加密结果：${outputText.value}\n解密结果：${inputText.value}`;
      const blob = new Blob([code], {
        type: 'text/plain'
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'base64_code.txt';
      link.click();
    };

    // 复制代码
    const copyCode = () => {
      const code = `加密结果：${outputText.value}\n解密结果：${inputText.value}`;
      navigator.clipboard.writeText(code).then(() => {
        console.log('复制成功');
      }).catch(err => {
        console.log('复制失败', err);
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inputText.value = $event),
        rows: "10",
        placeholder: "请输入内容"
      }, null, 512), [[_vModelText, inputText.value]])]), _createElementVNode("div", {
        class: "button-group"
      }, [_createElementVNode("button", {
        onClick: base64Encode,
        class: "action-btn"
      }, "Base64 加密"), _createElementVNode("button", {
        onClick: base64Decode,
        class: "action-btn"
      }, "Base64 解密"), _createElementVNode("button", {
        onClick: swapContents,
        class: "action-btn"
      }, "交换内容"), _createElementVNode("button", {
        onClick: clearContents,
        class: "action-btn"
      }, "清空")]), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => encoding.value = $event),
        class: "encoding-select"
      }, _hoisted_7, 512), [[_vModelSelect, encoding.value]]), _createElementVNode("div", {
        class: "code-ops"
      }, [_createElementVNode("button", {
        onClick: downloadCode,
        class: "code-btn"
      }, "下载加密/解密代码"), _createElementVNode("button", {
        onClick: copyCode,
        class: "code-btn"
      }, "复制加密/解密代码")]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => outputText.value = $event),
        rows: "10",
        placeholder: "显示结果"
      }, null, 512), [[_vModelText, outputText.value]])])]);
    };
  }
};